import { render, staticRenderFns } from "./DialogCheckbox.vue?vue&type=template&id=2bdc08d0&"
import script from "./DialogCheckbox.vue?vue&type=script&lang=js&"
export * from "./DialogCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DialogCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VTooltip})
